"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MultiOffer = void 0;
var _i18n = require("@ori/i18n");
var _productList = require("@ori/product-list");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _reactCoolInview = require("react-cool-inview");
var _constants = require("../../../../constants");
var _contexts = require("../../../../contexts");
var _models = require("../../../../models");
var _Product = require("../Product");
var _styles = require("./styles");
var _utils = require("./utils");
var _jsxRuntime = require("react/jsx-runtime");
/**
 * Component to render multiple offer products.
 * It will render multiple products in a carousel or a list based on `MAX_OFFER_CAROUSEL_ITEMS_COUNT`.
 */
const MultiOffer = () => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    offer,
    offerItems,
    totalRecords,
    loading,
    loadMore
  } = (0, _contexts.useOfferDetail)();
  const {
    choiceId: offerId
  } = offer;
  // istanbul ignore next -- not testable
  const onEnter = ({
    unobserve
  }) => {
    loadMore();
    unobserve();
  };
  const {
    observe
  } = (0, _reactCoolInview.useInView)({
    onEnter
  });
  const renderItemComponent = (0, _react.useCallback)(({
    item: product,
    index
  }) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_i18n.TranslationsNamespaceProvider, {
    namespace: _constants.translationsNamespace,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      ref: totalRecords === _constants.MAX_OFFER_CAROUSEL_ITEMS_COUNT && index === 1 ? observe : undefined,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Product.Product, {
        offerItem: product,
        position: index
      }, product.itemCode)
    })
  }), [observe, totalRecords]);
  const initialLoading = (0, _react.useMemo)(() => loading && offerItems.length === 0, [loading, offerItems.length]);
  const productListHybridModeConfig = (0, _react.useMemo)(() => (0, _utils.getProductListHybridModeConfig)(offerId), [offerId]);
  const testId = totalRecords > _constants.MAX_OFFER_CAROUSEL_ITEMS_COUNT ? _models.TestId.OfferList : _models.TestId.OfferCarousel;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Root, {
    "data-testid": getTestId(testId),
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_productList.ProductList, {
      shouldRenderPagination: true,
      items: offerItems,
      shouldRenderItemCount: false,
      renderItemComponent: renderItemComponent,
      mode: productListHybridModeConfig,
      totalItemCount: totalRecords,
      loadedItemCount: offerItems.length,
      loadMoreItems: loadMore,
      isLoadingMore: loading,
      isRefreshing: initialLoading,
      withTranslationsProvider: false
    })
  });
};
exports.MultiOffer = MultiOffer;